import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import adTypeFromPost from '../../helpers/adTypeFromPost';
import { AdTypeIcon, Dotdotdot, Icon, SocialNetworkIcon, SocialNetworkIconBar, Spinner, Tooltip } from 'components';
import Linkify from 'react-linkify';
import styles from './PostCard.scss';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';

var URL = require('url-parse');

var request = require('superagent');

var PostCard = /*#__PURE__*/function (_Component) {
  _inherits(PostCard, _Component);

  var _super = _createSuper(PostCard);

  function PostCard(props) {
    var _this;

    _classCallCheck(this, PostCard);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "checkVideoUrl", function (videoUrl) {
      return new Promise(function (resolve, reject) {
        request.head(videoUrl).end(function (err, res) {
          if (err) {
            reject(err);
          } else {
            resolve(res);
          }
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "formatObjective", function (obj) {
      if (!obj) {
        return '';
      }

      var parts = obj.split('_');
      var words = [];
      parts.forEach(function (word) {
        words.push("".concat(word.charAt(0).toUpperCase()).concat(word.slice(1).toLowerCase()));
      });
      return words.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "getSocialNetworks", function () {
      var socialNetworks = new Set();
      var post = _this.props.post;

      if (post.QueueId && post.Queue) {
        // postType = 'auto';
        socialNetworks.add(post.Queue.type.split(' ')[0].toLowerCase());
      } else if (_this.props.post.type === 'AD') {
        // postType = 'ad';
        // TODO someday...undo this hard coding and be able to show twitter or instagram
        socialNetworks.add('facebook');
      } else {
        // postType = 'custom';
        if (post.SocialAccountPosts) {
          post.SocialAccountPosts.forEach(function (account) {
            try {
              socialNetworks.add(account.SocialAccount.platform.split(' ')[0].toLowerCase());
            } catch (e) {
              return [];
            }
          });
        } else if (post.SocialAccountPostTemplates) {
          post.SocialAccountPostTemplates.forEach(function (account) {
            try {
              socialNetworks.add(account.accountPlatform.split(' ')[0].toLowerCase());
            } catch (e) {
              return [];
            }
          });
        }
      }

      console.log(socialNetworks);
      return socialNetworks;
    });

    _defineProperty(_assertThisInitialized(_this), "getImages", function (post) {
      var images = [];

      if (post.type === 'AD') {
        images.push( /*#__PURE__*/React.createElement("img", {
          role: "presentation",
          key: 0,
          src: post.adDetails.creative.thumbnail_url,
          style: {
            objectFit: 'cover',
            width: 250,
            height: 250
          }
        }));
      } else if (post.imageUrl && !post.videoUrl) {
        if (post.S3Files && post.S3Files.length) {
          images = post.S3Files.map(function (file, idx) {
            var width = 250;
            var height = 250;

            if (post.S3Files.length === 4) {
              width = 125;
              height = 125;
            } else if (post.S3Files.length === 3) {
              if (idx === 2) {
                width = 250;
              } else {
                width = 125;
              }

              height = 125;
            } else if (post.S3Files.length === 2) {
              width = 125;
              height = 250;
            }

            return /*#__PURE__*/React.createElement("img", {
              key: idx,
              role: "presentation",
              src: file.fullyQualifiedUrl.indexOf('.mp4') !== -1 ? file.fullyQualifiedUrl.replace('.mp4', '.jpg') : file.fullyQualifiedUrl,
              style: {
                objectFit: 'cover',
                width: width,
                height: height
              }
            });
          });
        } else if (post.imageUrl) {
          images.push( /*#__PURE__*/React.createElement("img", {
            role: "presentation",
            key: 0,
            src: post.imageUrl,
            style: {
              objectFit: 'cover',
              width: 250,
              height: 250
            }
          }));
        }
      }

      var imgStyle = post.type === 'AD' ? {
        borderRadius: 0,
        height: "".concat(_this.props.size || 250, "px")
      } : {
        height: "".concat(_this.props.size || 250, "px")
      };
      return post.imageUrl && !post.videoUrl || post.type === 'AD' ? /*#__PURE__*/React.createElement("div", {
        className: styles.imgPreview,
        style: imgStyle
      }, images) : null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderStats", function (post) {
      if (_this.props.statsLoading) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            height: 75,
            position: 'relative'
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-spinner fa-spin",
          style: {
            display: 'block',
            textAlign: 'center',
            fontSize: 25
          }
        }));
      }

      var stats = post.stats || [];
      var fbPageStats = stats.find(function (stat) {
        return stat.platform.toLowerCase() === 'facebook page';
      });
      var fbProfileStats = stats.find(function (stat) {
        return stat.platform.toLowerCase() === 'facebook profile';
      });
      var twitterStats = stats.find(function (stat) {
        return stat.platform.toLowerCase() === 'twitter';
      });
      var statsRows = [];

      if (fbPageStats) {
        var hasComments = fbPageStats.stats && fbPageStats.stats.comments !== null;
        var hasLikes = fbPageStats.stats && fbPageStats.stats.likes !== null;
        var hasShares = fbPageStats.stats && fbPageStats.stats.shares !== null;

        if (hasComments || hasLikes || hasShares) {
          statsRows.push(_this.renderStatsRow('facebook page', fbPageStats.stats));
        }
      }

      if (fbProfileStats) {
        var _hasComments = fbPageStats.stats && fbPageStats.stats.comments !== null;

        var _hasLikes = fbPageStats.stats && fbPageStats.stats.likes !== null;

        var _hasShares = fbPageStats.stats && fbPageStats.stats.shares !== null;

        if (_hasComments || _hasLikes || _hasShares) {
          statsRows.push(_this.renderStatsRow('facebook profile', fbProfileStats.stats));
        }
      }

      if (twitterStats) {
        var hasFavorites = twitterStats.stats && twitterStats.stats.favorites !== null;
        var hasRetweets = twitterStats.stats && twitterStats.stats.retweets !== null;

        if (hasFavorites || hasRetweets) {
          statsRows.push(_this.renderStatsRow('twitter', twitterStats.stats));
        }
      }

      return statsRows;
    });

    _defineProperty(_assertThisInitialized(_this), "renderStatsRow", function (platform, stats) {
      switch (platform) {
        case 'facebook page':
        case 'facebook profile':
          return /*#__PURE__*/React.createElement("div", {
            className: styles.statsContainer
          }, /*#__PURE__*/React.createElement("div", {
            className: styles.statsNetworkIcon
          }, /*#__PURE__*/React.createElement(SocialNetworkIcon, {
            network: "facebook"
          })), /*#__PURE__*/React.createElement("div", {
            className: styles.statIconWrap
          }, /*#__PURE__*/React.createElement("i", {
            className: "fa fa-thumbs-o-up"
          }), /*#__PURE__*/React.createElement("span", {
            className: styles.stat
          }, stats.likes)), /*#__PURE__*/React.createElement("div", {
            className: styles.statIconWrap
          }, /*#__PURE__*/React.createElement("i", {
            className: "fa fa-comment-o"
          }), /*#__PURE__*/React.createElement("span", {
            className: styles.stat
          }, stats.comments)), /*#__PURE__*/React.createElement("div", {
            className: styles.statIconWrap
          }, /*#__PURE__*/React.createElement("i", {
            className: "fa fa-share"
          }), /*#__PURE__*/React.createElement("span", {
            className: styles.stat
          }, stats.shares)));

        case 'twitter':
          return /*#__PURE__*/React.createElement("div", {
            className: styles.statsContainer
          }, /*#__PURE__*/React.createElement("div", {
            className: styles.statsNetworkIcon
          }, /*#__PURE__*/React.createElement(SocialNetworkIcon, {
            network: "twitter"
          })), /*#__PURE__*/React.createElement("div", {
            className: styles.statIconWrap
          }, /*#__PURE__*/React.createElement("i", {
            className: "fa fa-retweet"
          }), /*#__PURE__*/React.createElement("span", {
            className: styles.stat
          }, stats.retweets)), /*#__PURE__*/React.createElement("div", {
            className: styles.statIconWrap
          }, /*#__PURE__*/React.createElement("i", {
            className: "fa fa-heart-o"
          }), /*#__PURE__*/React.createElement("span", {
            className: styles.stat
          }, stats.favorites)));

        default:
          return '';
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderAdTopBar", function () {
      var post = _this.props.post;
      var adType = adTypeFromPost(post);
      return /*#__PURE__*/React.createElement("div", {
        className: styles.adTopBar
      }, /*#__PURE__*/React.createElement(AdTypeIcon, {
        style: {
          "float": 'left'
        },
        adType: post.adDetails.campaign.objective,
        size: "medium"
      }), /*#__PURE__*/React.createElement("span", {
        className: styles.goalLargeText
      }, _this.formatObjective(post.adDetails.campaign.objective), " AD"));
    });

    _this.state = {
      validVideo: false
    };
    return _this;
  }

  _createClass(PostCard, [{
    key: "UNSAFE_componentWillMount",
    value:
    /** *********************************************************
     LIFECYCLE METHODS
     ***********************************************************/
    function UNSAFE_componentWillMount() {
      var _this2 = this;

      if (this.props.post && this.props.post.videoUrl) {
        this.checkVideoUrl(this.props.post.videoUrl).then(function () {
          _this2.setState({
            validVideo: true
          });
        })["catch"](function (err) {
          console.error(err);

          _this2.setState({
            validVideo: false
          });
        });
      }
    }
    /** *********************************************************
     CUSTOM METHODS
     ***********************************************************/

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          actions = _this$props.actions,
          editBtns = _this$props.editBtns,
          post = _this$props.post,
          menuOptions = _this$props.menuOptions;
      var source = this.props.post.linkUrl || '';

      if (source) {
        var url = new URL(source, {});
        source = url.hostname;
      }

      var imageSection = this.getImages(post);
      var videoSection = post.videoUrl && (this.state.validVideo || post.videoUrl.indexOf('https://s3.amazonaws.com/storyfactory/') === 0) ? /*#__PURE__*/React.createElement("video", {
        width: "".concat(this.props.size || 250, "px"),
        autoPlay: true,
        loop: true,
        muted: true
      }, /*#__PURE__*/React.createElement("source", {
        src: post.videoUrl,
        type: "video/mp4"
      })) : '';
      var platformWithError = '';

      if (this.props.hasPostingError) {
        if (post && post.PostResult && post.PostResult.results && post.PostResult.results.length) {
          post.PostResult.results.forEach(function (r) {
            if (r.error) {
              platformWithError = r.account.platform;
            }
          });
        }
      }

      var invalidVideoSection = post.videoUrl && !this.state.validVideo && post.videoUrl.indexOf('https://s3.amazonaws.com/storyfactory/') === -1 ? /*#__PURE__*/React.createElement("div", {
        className: styles.imgPreview,
        style: {
          backgroundImage: 'url(https://likeabucket.s3.amazonaws.com/fdv6tfebng_1492611855092.jpg)',
          height: "".concat(this.props.size || 250, "px")
        }
      }) : null;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.postCard,
        style: {
          width: "".concat(this.props.size || 250, "px")
        }
      }, menuOptions && menuOptions.length > 0 && /*#__PURE__*/React.createElement(IconMenu, {
        iconButtonElement: /*#__PURE__*/React.createElement("i", {
          style: {
            top: 30
          },
          className: "icon ion-ios-more ".concat(styles.closeButton)
        }),
        anchorOrigin: {
          horizontal: 'left',
          vertical: 'top'
        },
        targetOrigin: {
          horizontal: 'left',
          vertical: 'top'
        }
      }, menuOptions), this.props.onClose && /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-close-empty ".concat(styles.closeButton),
        onClick: this.props.onClose
      }), post.type === 'AD' && this.renderAdTopBar(), imageSection, invalidVideoSection, videoSection, /*#__PURE__*/React.createElement("div", {
        className: styles.bodyWrap,
        style: !post.imageUrl && !post.videoUrl ? {
          paddingRight: '12px',
          paddingTop: '20px'
        } : {}
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.innerWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.textWrap
      }, this.props.parsingLink && /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          height: 50
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-spinner fa-spin",
        style: {
          display: 'block',
          textAlign: 'center',
          fontSize: 25
        }
      })), post.title && /*#__PURE__*/React.createElement("h2", {
        className: styles.title
      }, post.title), /*#__PURE__*/React.createElement("span", {
        className: styles.message
      }, this.props.linkify ? /*#__PURE__*/React.createElement(Linkify, {
        properties: {
          target: '_blank',
          rel: 'noopener'
        }
      }, post.displayMessage ? post.displayMessage : post.message) : post.displayMessage ? post.displayMessage : post.message), this.props.hasPostingError && /*#__PURE__*/React.createElement("span", {
        className: styles.message,
        style: {
          alignItems: 'center',
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-exclamation-triangle",
        style: {
          color: 'darkred',
          marginRight: 8
        }
      }), /*#__PURE__*/React.createElement("span", {
        style: {
          color: 'darkred'
        }
      }, "There was an error posting this item. Please reconnect your ", platformWithError, " account and try again.")), source && /*#__PURE__*/React.createElement("a", {
        href: post.linkUrl,
        target: "_blank",
        style: {
          color: '#8b8b8b',
          fontSize: 12,
          paddingTop: 2,
          paddingBottom: 4
        }
      }, source), /*#__PURE__*/React.createElement("div", {
        className: styles.detailsRow
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.socialIconsWrap
      }, (this.props.post.isBoostable || this.props.post.QueueId) && /*#__PURE__*/React.createElement("span", {
        className: styles.boostableIcon
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "bullhorn"
      })), /*#__PURE__*/React.createElement(SocialNetworkIconBar, {
        networks: this.getSocialNetworks(),
        style: {
          marginTop: 3
        }
      })), post.pastPost && /*#__PURE__*/React.createElement("div", {
        className: styles.controlIconWrap,
        style: {
          flex: '0 0 40px',
          padding: 0
        }
      }, editBtns ? editBtns[0] : []), post.publishAt && post.type !== 'AD' && /*#__PURE__*/React.createElement("span", {
        className: styles.time
      }, this.props.publishAtTime)))), !post.pastPost && editBtns.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: styles.editBtnsContainer
      }, editBtns ? editBtns.map(function (btn, idx) {
        return /*#__PURE__*/React.createElement("div", {
          key: idx,
          className: styles.controlIconWrap
        }, btn);
      }) : null), actions && /*#__PURE__*/React.createElement("div", {
        className: styles.actionsContainer
      }, actions ? actions.map(function (action, idx) {
        return /*#__PURE__*/React.createElement("div", {
          key: idx,
          className: styles.controlIconWrap
        }, action);
      }) : null), post.pastPost && this.renderStats(post)));
    }
  }]);

  return PostCard;
}(Component);

_defineProperty(PostCard, "propTypes", {
  publishAtTime: PropTypes.string,
  actions: PropTypes.array,
  size: PropTypes.number,
  post: PropTypes.object.isRequired,
  onClose: PropTypes.func,
  editBtns: PropTypes.array,
  statsLoading: PropTypes.bool,
  linkify: PropTypes.bool
});

_defineProperty(PostCard, "defaultProps", {
  actions: null,
  onClose: function onClose() {},
  editBtns: [],
  parsingLink: false,
  hasPostingError: false
});

export { PostCard as default };